module.exports = __webpack_public_path__ + "static/media/call_to_action.5f9608e7.svg";